{
  "jira.jira-notify-reaction.message-template.text.single-reaction-with-name": ":bell: *{userName} hat auf Ihren Kommentar reagiert*",
  "jira.jira-notify-reaction.message-template.text.view-comment": "Kommentar anzeigen"
}